import { POST_SEARCH_RESULTS } from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  results: []
};

const postSearchResults = (state = initialState, action) => {
  switch(action.type) {
    case POST_SEARCH_RESULTS: return updateObject(state, action.payload)
    default:
      return state;
  }
}

export default postSearchResults;



// WEBPACK FOOTER //
// ./src/store/reducers/postSearchResults.js